export default {
    view: '/gateway/manageBedrock/free/noticecs/view', // 公告列表查询
}


// WEBPACK FOOTER //
// ./src/geelyNotice/detail/api.js